var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPermission('tickets.change_ticket'))?_c('el-button',{attrs:{"loading":_vm.loading,"type":"danger"},on:{"click":function($event){return _vm.confirmUnbindTicket()}}},[_vm._v("\n  Usuń bilet z konta użytkownika\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }